import { FC, ReactNode } from 'react';

import CircularSpinner from 'components/loadingIndicator/CircularSpinner';

interface OrgCategoryDisplayProps {
  loading?: boolean;
  error?: string;
  label: ReactNode;
  value: ReactNode;
  strikethrough?: boolean;
  dim?: boolean;
}

export const OrgCategoryDisplay: FC<OrgCategoryDisplayProps> = ({
  loading,
  error,
  label,
  value,
  strikethrough,
  dim,
}) => {
  return (
    <div style={{
      textDecoration: strikethrough ? 'line-through' : 'none',
      lineHeight: '26px',
      opacity: dim ? 0.5 : 1,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
        <b>{label}</b>
        {loading ? (
          <div style={{ display: 'flex', gap: 3, alignItems: 'center' }}>
            <CircularSpinner size={14} />
            <span>Hämtar data</span>
          </div>
        ) : (
          <span style={{ color: value ? 'inherit' : 'red' }}>
            {error || value || 'Odefinierad'}
          </span>
        )}
      </div>
    </div>
  );
};
